// removed by extract-text-webpack-plugin
module.exports = {"vpCaptionPlayerContainer":"vpCaptionPlayerContainer___2bKDX","vpVideoContainer":"vpVideoContainer___UVtEn","landscape":"landscape___3icYy","portrait":"portrait___1li9n","captionOverlay":"captionOverlay___12CLl","captionText":"captionText___3LCNG","controlsBar":"controlsBar___C4BtU"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpVideoCaptionPlayer/VpVideoCaptionPlayer.module.less
// module id = 3211
// module chunks = 33